import { render } from "./Crosshair.vue?vue&type=template&id=4a72b5ad&scoped=true"
import script from "./Crosshair.vue?vue&type=script&lang=js"
export * from "./Crosshair.vue?vue&type=script&lang=js"

import "./Crosshair.vue?vue&type=style&index=0&id=4a72b5ad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a72b5ad"]])

export default __exports__